import { Navigate, Route, Routes } from 'react-router-dom';
import { SECCIONES_PANEL } from '../../App';
import { type PermisoPlataforma } from '../../lib/api-panel';
import { useApp } from '../../lib/contexto';
import { Esqueleto } from '../../ui/base';
import { Analistas } from './Analistas';
import { Auditoria } from './Auditoria';
import { Catalogos } from './Catalogos';
import { Indicadores } from './Indicadores';
import { Negocios } from './Negocios';
import { Operaciones } from './Operaciones';
import { Sesiones } from './Sesiones';

/**
 * El panel de administración, solo el contenido: encabezado y navegación son del layout, y cada
 * sección es una ruta, así refrescar no pierde la sección. «Panel» es esta pantalla; «plataforma»
 * es el producto entero, y por eso los permisos y los RPC conservan esa palabra.
 */
export function Panel() {
  const { perfilPanel } = useApp();

  if (perfilPanel === null) return <Esqueleto lineas={6} />;

  const puede = (p: PermisoPlataforma) => perfilPanel.permisos.includes(p);
  const primera = SECCIONES_PANEL.find((s) => puede(s.permiso));

  if (!primera) {
    return (
      <p className="text-muted text-contenido">
        Tu cuenta no tiene permisos de plataforma activos. Pide a un administrador que te los otorgue.
      </p>
    );
  }

  return (
    <Routes>
      <Route index element={<Navigate to={primera.ruta} replace />} />
      {puede('ver:indicadores') && (
        <Route path="indicadores" element={<Indicadores verMetricas={puede('ver:metricas')} />} />
      )}
      {puede('ver:negocios') && (
        <Route
          path="negocios"
          element={<Negocios puedeEscribir={puede('escribir:negocios')} esAdmin={perfilPanel.rol === 'admin'} />}
        />
      )}
      {puede('ver:operaciones') && <Route path="operaciones" element={<Operaciones />} />}
      {puede('ver:sesiones') && (
        <Route path="sesiones" element={<Sesiones puedeEscribir={puede('escribir:sesiones')} />} />
      )}
      {puede('ver:auditoria') && <Route path="auditoria" element={<Auditoria />} />}
      {puede('ver:catalogos') && <Route path="catalogos" element={<Catalogos puedeEscribir={puede('escribir:catalogos')} />} />}
      {puede('ver:analistas') && <Route path="equipo" element={<Analistas puedeEscribir={puede('escribir:analistas')} esAdmin={perfilPanel.rol === 'admin'} />} />}
      {/* Una sección sin permiso, o un nombre que no existe, cae en la primera que sí. */}
      <Route path="*" element={<Navigate to={`/panel/${primera.ruta}`} replace />} />
    </Routes>
  );
}
